import Snackbar from "components/Common/Snackbar"
import Unauthorized from "components/Common/Unauthorized"
import { AppContainer } from "contexts/App"
import { ClerkAppContainer } from "contexts/Clerk/ClerkApp"
import { MessagesContainer } from "contexts/Messages"
import AddBoard from "dialogs/AddBoard"
import ApplicantDialog from "dialogs/Applicant"
import ApplicantDetails from "dialogs/ApplicantDetails"
import ClerkMyAccount from "dialogs/ClerkMyAccount"
import ClerkResetPassword from "dialogs/ClerkResetPassword"
import ClickConfirmation from "dialogs/ClickConfirmation"
import CreateAdmin from "dialogs/CreateAdmin"
import CreateNewReviewer from "dialogs/CreateNewReviewer"
import DownloadApplicantProfile from "dialogs/DownloadApplicantProfile"
import EmailVerification from "dialogs/EmailVerification"
import FinishAccount from "dialogs/FinishAccount"
import Login from "dialogs/Login"
import UpdateAdmin from "dialogs/UpdateAdmin"
import UploadCsv from "dialogs/UploadCsv"
import WidgetEmbedTool from "dialogs/WidgetEmbedTool"
import { withRouter } from "react-router"
import Router, { clerkRouteConfig } from "router"

import useStyles from "./styles"

const Clerk = () => {
  const { classes } = useStyles()

  return (
    <AppContainer isClerk={true}>
      <ClerkAppContainer>
        <MessagesContainer>
          <Router routes={clerkRouteConfig} />
          <div id="dialog-holder">
            {/* LEAVE THIS IN PLACE FOR DIALOGS TO POPULATE INTO */}
            <ClerkResetPassword />
            <Login />
            <ClerkMyAccount />
            <ApplicantDialog />
            <FinishAccount />
            <CreateAdmin />
            <ClickConfirmation />
            <ApplicantDetails />
            <AddBoard />
            <EmailVerification />
            <UpdateAdmin />
            <DownloadApplicantProfile />
            <UploadCsv />
            <WidgetEmbedTool />
            <CreateNewReviewer />
          </div>
          <Snackbar />
          <Unauthorized />
        </MessagesContainer>
      </ClerkAppContainer>
    </AppContainer>
  )
}

export default withRouter(Clerk)
